/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { FluxAction } from '@saucelabs/sl-util-redux';

import {
  UsageAnalyticsConcurrencOrgResponse,
  UsageAnalyticsConcurrencTeamResponse,
  UsageAnalyticsActivity,
  UsageAnalyticsState,
  UsageAnalyticsGranularity,
} from './types';
import * as constants from './constants';
import { Team } from './api';

export const initialState: UsageAnalyticsState = {
  activity: [],
  loading: true,
  teamCache: {},
  granularity: constants.GRANULARITY_TYPES.DAILY,
};

const parseOrgActivity = (payload: UsageAnalyticsConcurrencOrgResponse) => ((
  payload.by_org.data.map<UsageAnalyticsActivity>(({ time, values }) => ({
    time: new Date(time),
    values,
  })).reverse()
));

const parseTeamActivity = (payload: UsageAnalyticsConcurrencTeamResponse) => {
  // API allows to query for multiple teams, UI only support single selection
  const firstTeam = payload.by_team[0];

  return (
    firstTeam.data.map<UsageAnalyticsActivity<'team'>>(({ time, values }) => ({
      teamId: firstTeam.team_id,
      time: new Date(time),
      values,
    })).reverse()
  );
};

export const reducer = createReducer(initialState, (builder) => builder
  .addCase<string, FluxAction<string, { results: Team[] }>>(
    constants.getTeamsConstants.SUCCESS,
    (state, action) => {
      const currentCache = state.teamCache;
      const newEntries = Object.fromEntries(
        action.payload.results.map(({ id, name }) => [id, name]),
      );

      state.teamCache = {
        ...currentCache,
        ...newEntries,
      };
    },
  )
  .addCase(constants.orgActivityConstants.REQUEST, (state) => {
    state.loading = true;
    state.activity = [];
  })
  .addCase<string, FluxAction<string, UsageAnalyticsConcurrencOrgResponse>>(
    constants.orgActivityConstants.SUCCESS,
    (state, action) => {
      state.activity = parseOrgActivity(action.payload);
      state.loading = false;
    },
  )

  .addCase(constants.teamActivityConstants.REQUEST, (state) => {
    state.loading = true;
    state.activity = [];
  })
  .addCase<string, FluxAction<string, UsageAnalyticsConcurrencTeamResponse>>(
    constants.teamActivityConstants.SUCCESS,
    (state, action) => {
      state.activity = parseTeamActivity(action.payload);
      state.loading = false;
    },
  )

  .addCase<string, FluxAction<string, UsageAnalyticsGranularity>>(
    constants.setGranularity,
    (state, payload) => {
      state.loading = true;
      state.granularity = payload.payload;
    },
  ),
);

export default reducer;
